<script>
import axios from '@/utils/axios';
import sideBarDataRaw from "@/assets/json/sidebar-data.json";
import { useFollowupStore } from '@/stores/useFollowupStore'

export default {
  data() {
    return {
      sideBarData: [],
      openMenuItem: null,
      openSubmenuOneItem: null,
      multilevel: [false, false, false, false],
      // todaysFollowupCount: 0,
    };
  },
  created() {
    this.filterSidebarData();
    this.setActiveMenu();
      this.followupStore = useFollowupStore();
  this.followupStore.loadFollowups();
  },
// async mounted() {
//   this.getTodaysFollowupCount();
//   this.followupInterval = setInterval(() => {
//     this.getTodaysFollowupCount();
//   }, 60000);
// },
beforeUnmount() {
  if (this.followupInterval) {
    clearInterval(this.followupInterval);
  }
},


  computed: {
    isMenuActive() {
      return (menu) =>
        this.$route.path === menu.route ||
        this.$route.path === menu.active_link;
    },
    isActive() {
      return (menu) => {
        const base = this.$route.path.split('/')[1];
        return base === menu.active_link;
      };
    },
    isSubActive() {
      return (menu) => {
        const base = this.$route.path.split('/')[1];
        return base === menu.active_link;
      };
    },
  },
     watch: {
    $route() {
      document.body.classList.remove("slide-nav");
       this.setActiveMenu();
    }
  },

  methods: {

// async getTodaysFollowupCount() {
//   try {
//     const response = await axios.get('/reminders/my/created');
//     this.todaysFollowupCount = response.data.data?.length || 0;
//   } catch (error) {
//     console.log(error.message);
//   }
// },


setActiveMenu() {
  const currentPath = this.$route.path;

  this.sideBarData.forEach((group) => {
    group.menu.forEach((menu) => {
      // Level 1: direct subMenus (e.g., Sales > Proposals, Stock > Inward Stock)
      if (menu.subMenus && !menu.hasSubRouteTwo) {
        const match = menu.subMenus.find((sub) =>
          sub.route && currentPath.includes(sub.route)
        );
        if (match) {
          menu.showSubRoute = true;
        }
      }

      // Level 2: nested subMenusTwo (e.g., Reports > Inventory > Stock In)
      if (menu.hasSubRouteTwo && menu.subMenus) {
        let parentMatch = false;
        
        menu.subMenus.forEach((sub) => {
          if (sub.customSubmenuTwo && sub.subMenusTwo) {
            const childMatch = sub.subMenusTwo.find((subTwo) =>
              subTwo.route && currentPath.includes(subTwo.route)
            );
            if (childMatch) {
              parentMatch = true;
              this.openMenuItem = menu;            // Reports open rahega
              this.openSubmenuOneItem = sub;       // Inventory bhi open rahega
            }
          }
        });
      }

      // direct menu match
      if (menu.route && currentPath.includes(menu.route)) {
        menu.showSubRoute = true;
      }
    });
  });
},


   filterSidebarData() {
  const type = this.auth.type;
  const permissions = this.auth.role?.permissions || [];
  const allowedModules = permissions.filter((p) => p.read).map((p) => p.module?.name);
  
  // Add client setting access (adjust path if in Pinia/store)
  const allowVariance = this.clientSetting?.allow_inventory_variance || false;
  
  const filtered = [];

  for (const group of sideBarDataRaw) {
    const menu = group.menu.map((m) => {
      // role-based top-level visibility
      if (m.showFor === "SUPER_ADMIN" && type !== "SUPER_ADMIN") return null;
      if (m.showFor === "ADMIN" && type !== "ADMIN") return null;

      // clone to avoid mutating raw json
      const menuItem = { ...m };

      // filter subMenus (Sales > Proposals, etc.)
      // filter subMenus (Sales > Proposals, etc.)
if (menuItem.subMenus && Array.isArray(menuItem.subMenus)) {
  menuItem.subMenus = menuItem.subMenus.filter((sub) => {

     if (sub.showFor === 'ADMIN' && type !== 'ADMIN') return false;
    // NEW: Combined ADMIN role + client setting check for Pending Variances
    if (sub.menuValue === 'Pending Variances') {
      const isAdmin = type === 'ADMIN';
      if (!isAdmin || !allowVariance) {
        return false;
      }
    }
    
    // Existing moduleName filter
    if (sub.moduleName) {
      return allowedModules.includes(sub.moduleName);
    }
    return true;
  });
}


      // for simple items with moduleName on the menu itself
      if (menuItem.moduleName && !menuItem.subMenus) {
        if (!allowedModules.includes(menuItem.moduleName)) {
          return null;
        }
      }

      // if this is a submenu parent and all children were removed, drop it
      // if (menuItem.hasSubRoute && menuItem.subMenus && menuItem.subMenus.length === 0) {
      //   return null;
      // }
      if ((menuItem.hasSubRoute || menuItem.hasSubRouteTwo) && menuItem.subMenus && menuItem.subMenus.length === 0) {
  return null;
}
      return menuItem;
    }).filter(Boolean); // remove nulls
    
    if (menu.length) {
      filtered.push({ ...group, menu });
    }
   }
   this.sideBarData = filtered;
  },

  expandSubMenus(menu) {
   this.sideBarData.forEach((item) =>
    item.menu.forEach((m) => (m.showSubRoute = m === menu && !m.showSubRoute))
   );
  },
  OpenMenu(menu) {
   this.openMenuItem = this.openMenuItem === menu ? null : menu;
  },
  openSubmenuOne(subMenus) {
   this.openSubmenuOneItem =
    this.openSubmenuOneItem === subMenus ? null : subMenus;
  },
 },
};
</script>


<template>
<ul>
<template v-for="item in sideBarData" :key="item.tittle">
<li class="menu-title">
<span>{{ item.tittle }}</span>
</li>  
<li>
<ul>
<template v-for="menu in item.menu" :key="menu.menuValue">
<li v-if="!menu.hasSubRoute" :class="{ 'active': isMenuActive(menu) }">
<router-link v-if="menu.route" :to="menu.route">
    <i :class="'ti ti-' + menu.icon"></i>
    <span>{{ menu.menuValue }}</span>
    <span v-if="menu.menuValue === `Today's Followup` && followupStore.count > 0"
      style="background:#ef4444; color:#fff; font-size:9px; font-weight:700; padding:1px 6px; border-radius:10px; margin-left:6px;">
      {{ followupStore.count }}
    </span>
</router-link>
</li>
<li v-else class="submenu">
<a href="javascript:void(0);" @click="expandSubMenus(menu)" 
:class="{ subdrop: menu.showSubRoute && !openMenuItem, 'active': isActive(menu) }">
    <i :class="'ti ti-' + menu.icon"></i><span>{{ menu.menuValue }}</span>
    <span v-if="menu.currentActive" class="badge badge-danger fs-10 fw-medium text-white p-1">Hot</span>
    <span class="menu-arrow"></span>
</a>
<ul class="submenu-slide" :class="{ 'submenu-open': menu.showSubRoute }">
    <li v-for="(subMenu, index) in menu.subMenus" :key="index">
        <router-link :to="subMenu.route">{{ subMenu.menuValue }}</router-link>
    </li>
</ul>
</li>
<li v-if="menu.hasSubRouteTwo" class="submenu">
<a href="javascript:void(0);" @click="OpenMenu(menu)"
:class="{ subdrop: openMenuItem === menu || isActive(menu), 'active': isActive(menu) }">
    <i :class="'ti ti-' + menu.icon"></i><span>{{ menu.menuValue }}</span>
    <span class="menu-arrow"></span>
</a>
<ul class="submenu-slide" :class="{ 'submenu-open': openMenuItem === menu }">
<li v-for="subMenus in menu.subMenus" :key="subMenus.menuValue">
<template v-if="!subMenus.customSubmenuTwo">
<router-link :to="subMenus.route" router-link-active="active">{{ subMenus.menuValue }}</router-link>
</template>
<template v-else-if="subMenus.customSubmenuTwo">
<li class="submenu submenu-two">
<a href="javascript:void(0);" @click="openSubmenuOne(subMenus)"
:class="{ subdrop: openSubmenuOneItem === subMenus || isSubActive(subMenus), 'active': isSubActive(subMenus) }">
  {{ subMenus.menuValue }}<span class="menu-arrow inside-submenu"></span>
</a>
<ul class="submenu-slide" :class="{ 'submenu-open': openSubmenuOneItem === subMenus }">
  <li v-for="subMenuTwo in subMenus.subMenusTwo" :key="subMenuTwo.menuValue">
      <router-link :to="subMenuTwo.route">{{ subMenuTwo.menuValue }}</router-link>
  </li>
</ul>
</li>
</template>
</li>                                
</ul>
</li>                    
</template>							
</ul>
</li>
</template>
<!-- <li class="menu-title"><span>Extras</span></li>
<li>
<ul>
<li>
<a href="javascript:void(0);"><i class="ti ti-file-text"></i><span>Documentation</span></a>
</li>
<li>
<a href="javascript:void(0);"><i class="ti ti-exchange"></i><span>Changelog</span><span class="badge bg-pink badge-xs text-white fs-10 ms-s">v4.0.2</span></a>
</li>
<li class="submenu">
<a href="javascript:void(0);" :class="{ subdrop: multilevel[0] }" @click="multilevel[0] = !multilevel[0]">
<i class="ti ti-menu-2"></i>
<span>Multi Level</span>
<span class="menu-arrow"></span>
</a>
<ul :class="{ 'd-block': multilevel[0], 'd-none': !multilevel[0] }">
<li>
<a href="javascript:void(0);" :class="{ subdrop: multilevel[1] }" @click="multilevel[1] = !multilevel[1]">Multilevel 1</a>
</li>
<li class="submenu submenu-two">
<a href="javascript:void(0);" :class="{ subdrop: multilevel[2] }" @click="multilevel[2] = !multilevel[2]">Multilevel 2<span class="menu-arrow inside-submenu"></span></a>
<ul :class="{ 'd-block': multilevel[2], 'd-none': !multilevel[2] }">
    <li><a href="javascript:void(0);">Multilevel 2.1</a></li>
    <li class="submenu submenu-two submenu-three">
        <a href="javascript:void(0);" :class="{ subdrop: multilevel[3] }" @click="multilevel[3] = !multilevel[3]">Multilevel 2.2<span class="menu-arrow inside-submenu inside-submenu-two"></span></a>
        <ul :class="{ 'd-block': multilevel[3], 'd-none': !multilevel[3] }">
            <li><a href="javascript:void(0);">Multilevel 2.2.1</a></li>
            <li><a href="javascript:void(0);">Multilevel 2.2.2</a></li>
        </ul>
    </li>
</ul>
</li>
<li><a href="javascript:void(0);">Multilevel 3</a></li>
</ul>
</li>
</ul>
</li> -->
</ul>
</template>
